<div class="dashboard-banner" *ngIf="showIS4UPSBanner">
  <div class="banner d-flex flex-row">
    <img src="../../../assets/images/acute-is4u.png">
    <div class="banner-contents">
      <div>Your offer is waiting! You have {{ is4upsDaysLeft }} left to upgrade your policy.</div>
      <a class="link" (click)="goToIS4UPS()">Act Now!<span><mat-icon>keyboard_arrow_right</mat-icon></span></a>
    </div>
    <img src="../../../assets/images/close.png" class="close" (click)="closeIS4UPSBanner()">
  </div>
</div>